<template>
  <div v-if="userData" class="main-container-shipmentinfo">
    <div class="inner-container" id="printable-content">
        <div class="confirm-container-main">
                <div class="close-shipment-info-container">
                    <svg class="close-shipment-info" @click="closeAddressInfo()" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                        <path d="M255.997 460.351c112.685 0 204.355-91.668 204.355-204.348S368.682 51.648 255.997 51.648c-112.68 0-204.348 91.676-204.348 204.355s91.668 204.348 204.348 204.348zm0-376.463c94.906 0 172.123 77.209 172.123 172.115 0 94.898-77.217 172.117-172.123 172.117-94.9 0-172.108-77.219-172.108-172.117-.001-94.906 77.207-172.115 172.108-172.115z" fill="#32ccfe" class="fill-000000"></path>
                        <path d="M172.077 341.508a18.35 18.35 0 0 0 12.903 5.27c4.776 0 9.54-1.84 13.151-5.512l57.865-58.973 57.878 58.973a18.372 18.372 0 0 0 13.146 5.512c4.658 0 9.316-1.746 12.902-5.27 7.264-7.125 7.369-18.793.242-26.051l-58.357-59.453 58.357-59.461c7.127-7.258 7.021-18.92-.242-26.047-7.252-7.123-18.914-7.018-26.049.24l-57.878 58.971-57.865-58.971c-7.135-7.264-18.797-7.363-26.055-.24-7.258 7.127-7.369 18.789-.236 26.047l58.351 59.461-58.351 59.453c-7.131 7.258-7.02 18.926.238 26.051z" fill="#32ccfe" class="fill-000000"></path>
                    </svg>
                </div>
                
                <div class="confirm-header-container">
                    <h1 class="package-details-header">User Details</h1>
                    <img src="../../../assets/LREXDinoFooter.jpg" alt="">
                </div>

                <div class="inner-overflow-container" id="inner-overflow-container">
                        <!-- <div class="confirmContainerInner">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1">
                                    <div class="confirm-svg">
                                        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.75 148.87">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M154.27,12.53c.87-.17,1.78,0,2.54,.46,1.29,.53,2.2,1.79,2.2,3.28l.74,103.46c.07,1.27-.56,2.54-1.73,3.22l-42.25,25.21c-.6,.46-1.34,.72-2.15,.72-.2,0-.39-.01-.57-.05L3.39,136.62c-1.89-.08-3.39-1.64-3.39-3.55V27.85H0c-.04-1.4,.75-2.77,2.13-3.37L57.14,.31h0c.57-.26,1.22-.36,1.9-.27l95.23,12.49h0Zm-37.27,30.93v96.48l36-21.47-.7-97.26-35.3,22.25h0Zm-7,97.91V45l-46.8-5.97-1.54,44.72-16.43-11.19-16.43,9.29,3.4-46.78-25.19-3.21v98.07l103,11.44h0ZM102.56,12.88l-34.52,19.59,44.9,5.72,31.47-19.83-41.86-5.49h0ZM36.56,28.46L70.02,8.61l-11.03-1.44L16.4,25.89l20.15,2.56h0Z"/>
                                            </g>
                                        </svg>
                                        <h2>Delivery Address</h2>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <p name="companyName">{{userData.UserName}}</p>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <p name="address1">{{userData.UserAddress[0].Address1}}</p>
                                    </div>
                                    
                                    <div v-if="userData.UserAddress[0].Address2" class="confirmLabelContainer">
                                        <p name="address2">{{userData.UserAddress[0].Address2}}</p>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <p name="city">{{userData.UserAddress[0].City}}, {{userData.UserAddress[0].State}} {{userData.UserAddress[0].ZipCode}}</p>
                                    </div>

                                    <div v-if="userData.UserEmail" class="confirmLabelContainer">
                                        <label for="contactName">User Email:</label>
                                        <p style="white-space: nowrap;" name="contactName">{{userData.UserEmail}}</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div v-if="userData.locationAddress" class="confirmContainerInner locationContainer">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1">
                                    <div class="confirm-svg">
                                        <svg style="padding-left: 5px;" height="50px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 180.36">
                                            <g id="image">
                                                <path d="M83.82,107.32c-.8,.6-1.89,.64-2.73,.09-9.02-5.68-17.02-12.82-23.68-21.13-8.16-9.91-13.64-21.75-15.94-34.38-1.89-11.72-.09-22.99,5.78-32.17,2.37-3.73,5.35-7.03,8.8-9.77C63.62,3.64,73.14,.13,82.99,0c9.55,.15,18.69,3.88,25.62,10.45,2.66,2.44,4.96,5.25,6.84,8.33,6.27,10.27,7.62,23.48,4.86,36.86-4.67,21.46-17.84,40.1-36.49,51.68Zm-26.82,1.36v40.6l44,18.97v-52.69l8-7.93v60.34l37-18.63V67.47l-15.02,5.78c1.51-3.98,2.75-8.06,3.72-12.2l14.53-5.61c2.58-.94,5.44,.36,6.42,2.92,.23,.58,.34,1.19,.34,1.81v92.18c0,1.93-1.16,3.68-2.95,4.42l-45.95,23.08c-1.35,.68-2.95,.68-4.3,0l-51.55-22.34L6.89,179.85c-2.34,1.18-5.19,.25-6.37-2.09,0,0,0,0,0,0C.18,177.09,0,176.36,0,175.62V78.41c0-2.22,1.46-4.17,3.59-4.8l25.36-9.78c.94,3.19,2.06,6.33,3.34,9.4l-22.29,8.59v86.19l37-18.63v-51.2c3.11,3.71,6.45,7.22,10,10.51ZM81.22,20.85c11.12,0,20.13,9.01,20.13,20.13s-9.01,20.13-20.13,20.13-20.13-9.01-20.13-20.13,9.01-20.13,20.13-20.13h0Z" style="fill: #000; fill-rule: evenodd;"/>
                                            </g>
                                        </svg>
                                        <h2>Location</h2>
                                    </div>

                                    <div v-show="userData.locationAddress.labelImage" class="confirmLabelContainer">
                                        <img :src="userData.locationAddress.labelImage" alt="">
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <p name="companyName">{{userData.locationAddress.serviceAddress.address.companyName}}</p>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <p name="address1">{{userData.locationAddress.serviceAddress.address.address1}}</p>
                                    </div>
                                    
                                    <div v-if="userData.locationAddress.serviceAddress.address.address2" class="confirmLabelContainer">
                                        <p name="address2">{{userData.locationAddress.serviceAddress.address.address2}}</p>
                                    </div>
                                    
                                    <div class="confirmLabelContainer">
                                        <p name="city">{{userData.locationAddress.serviceAddress.address.city}}, {{userData.locationAddress.serviceAddress.address.state}} {{userData.locationAddress.serviceAddress.address.zipCode}}</p>
                                    </div>

                                    <div v-if="userData.locationAddress.serviceAddress.address.phone" class="confirmLabelContainer">
                                        <label for="contactName">User Phone:</label>
                                        <p style="white-space: nowrap;" name="contactName">{{userData.locationAddress.serviceAddress.address.phone}}</p>
                                    </div>

                                    <div v-if="userData.userEmail" class="confirmLabelContainer">
                                        <label for="contactName">User Email:</label>
                                        <p style="white-space: nowrap;" name="contactName">{{userData.userEmail}}</p>
                                    </div>

                                    <div class="webkey-container">
                                        <p class="web-key-label">Webkey</p>
                                        <input @click="copyWebKey()" maxlength="20" type="text" readonly v-model="userData.webKey" placeholder="Webkey">
                                        <button @click="generateWebKey()" class="print-button">Generate Webkey</button>
                                        <button class="print-button create-button" @click="UpdateUserGraphQL()">Update Webkey</button>
                                    </div>
                                    
                                    <div v-if="AdminUser">
                                        <div v-for="attribute in usersAttributeData" :key="attribute.Name">
                                            <div class="confirmLabelContainer group-remove-add" v-if="(attribute.Name !== 'sub') && (attribute.Name !== 'email_verified')">
                                                <div>
                                                    <label for="">{{capitalizeFirstLetter(attribute.Name)}}</label>
                                                    <p style="font-size: 10px;">{{attribute.Value}}</p>
                                                </div>
                                                <button @click="toggleEditMode(attribute)" id="remove-button" style="margin-bottom: 0px;" class="print-button">Update</button>
                                            </div>
                                            <div class="confirmLabelContainer group-remove-add" v-if="(attribute.Name !== 'sub') && (attribute.Name !== 'email_verified') && (attributeToEdit.Name == attribute.Name)">
                                                <div>
                                                    <label for="">Update {{capitalizeFirstLetter(attribute.Name)}}</label>
                                                    <input style="font-size: 15px; margin-bottom: 5px;" type="text" v-model="attributeToEdit.Value">
                                                </div>
                                                <button @click="updateUsersAttributeDataFunc()" id="remove-button" style="margin-bottom: 0px;" class="print-button create-button">Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div v-if="loadingUserAttributes">
                                        <loading-charts/>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="confirm-container-address"> -->
                                <div class="confirmContainerInner1 notifications-container">
                                    <div class="notifications-container-1">
                                            <div class="confirm-svg notifications notificationHeader">
                                                <svg data-name="Livello 1" viewBox="10 12.5 40 40" xmlns="http://www.w3.org/2000/svg"><path d="M1 33A32 32 0 1 0 33 1 32 32 0 0 0 1 33Z" fill="none" class="fill-000000"></path><rect height="24.18" rx="1.48" ry="1.48" width="32" x="17" y="21" stroke-miterlimit="10" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></rect><path d="M48.44 21.83 37.53 33.54a6.27 6.27 0 0 1-9.07 0l-10.9-11.7M39.19 31.75l8.96 12.76M26.98 31.88 17.7 44.51" stroke-linejoin="round" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></path></svg>
                                                <h2>Notifications</h2>
                                            </div>
                                            <div class="inputLabelNotification">
                                                <div class="inputLabelNotificationInner">
                                                    <label>Delivery</label>

                                                    <div class="inputButtonContainer">
                                                        <input class="notification-input-style" placeholder="Enter Email or Phone" name="delivery" id="deliveryInput" type="text" @input="inputNotify = $event.target.value">
                                                        <button type="submit" @click="inputIsValid()" onclick="document.getElementById('deliveryInput').value = '';">Add</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="emailsAddedContainer" v-if="(userData?.deliveryEmail?.length > 0 || userData?.deliveryPhone?.length > 0)">
                                                <div v-for="(items, index) in userData?.deliveryEmail || []" :key="items" class="addedItems">
                                                    <p>{{ userData.deliveryEmail[index] }}</p>
                                                    <button @click="RemoveEmail(index)" class="removeItemButton">Delete</button>
                                                </div>
                                                <div v-for="(items, index) in userData?.deliveryPhone || []" :key="items" class="addedItems">
                                                    <p>{{ userData.deliveryPhone[index] }}</p>
                                                    <button @click="RemovePhone(index)" class="removeItemButton">Delete</button>
                                                </div>
                                            </div>
                                            <div class="inputLabelNotification">
                                                <div class="inputLabelNotificationInner">
                                                    <label>Non-Delivery</label>

                                                    <div class="inputButtonContainer">
                                                        <input class="notification-input-style" placeholder="Enter Email or Phone" name="nonDelivery" id="nonDeliveryInput" type="text" @input="inputNotifyNonDelivery = $event.target.value">
                                                        <button type="submit" @click="inputIsValidNonDelivery()" onclick="document.getElementById('nonDeliveryInput').value = '';">Add</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="emailsAddedContainer" v-if="(userData?.nonDeliveryEmail?.length > 0 || userData?.nonDeliveryPhone?.length > 0)">
                                                <div v-for="(items, index) in userData?.nonDeliveryEmail || []" :key="items" class="addedItems">
                                                    <p>{{ userData.nonDeliveryEmail[index] }}</p>
                                                    <button @click="RemoveNonDelivEmail(index)" class="removeItemButton">Delete</button>
                                                </div>
                                                <div v-for="(items, index) in userData?.nonDeliveryPhone || []" :key="items" class="addedItems" >
                                                    <p>{{ userData.nonDeliveryPhone[index] }}</p>
                                                    <button @click="RemoveNonDelivPhone(index)" class="removeItemButton">Delete</button>
                                                </div>
                                            </div>
                                        </div>

                                    <div class="delivery-instruction-container">
                                        <label class="deliveryInstructionsLabel" for="deliveryinstructions">Delivery Instructions</label>
                                        <textarea class="input-container-input" id="deliveryinstructions" type="text" v-model="userData.deliveryInstructions" cols="50" rows="5" maxlength="50"></textarea>
                                        <div class="char-counter">
                                            {{ userData.deliveryInstructions.length }} / 50 characters used
                                        </div>
                                    </div>

                                    <div class="delivery-instruction-container">
                                        <label class="deliveryInstructionsLabel" for="ref1">Reference</label>
                                        <textarea class="input-container-input" id="ref1" type="text" v-model="userData.ref1" cols="50" rows="5" maxlength="50"></textarea>
                                        <div class="char-counter">
                                            {{ (userData.ref1 || '').length }} / 50 characters used
                                        </div>
                                    </div>

                                    <button class="print-button create-button update-notification" @click="UpdateUserGraphQL()">Update Notifications</button>
                                </div>

                                <div class="confirmContainerInner1 temp-pass-container">
                                    <div class="notifications-container-1">
                                        <div class="confirm-svg notifications notificationHeader">
                                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                                                <path d="M11,15c0,.553-.448,1-1,1H5c-2.757,0-5-2.243-5-5v-3C0,5.243,2.243,3,5,3h14c2.757,0,5,2.243,5,5,0,.553-.447,1-1,1s-1-.447-1-1c0-1.654-1.346-3-3-3H5c-1.654,0-3,1.346-3,3v3c0,1.654,1.346,3,3,3h5c.552,0,1,.447,1,1Zm-2.293-7.707c-.391-.391-1.023-.391-1.414,0l-.793,.793-.793-.793c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414l.793,.793-.793,.793c-.391,.391-.391,1.023,0,1.414,.195,.195,.451,.293,.707,.293s.512-.098,.707-.293l.793-.793,.793,.793c.195,.195,.451,.293,.707,.293s.512-.098,.707-.293c.391-.391,.391-1.023,0-1.414l-.793-.793,.793-.793c.391-.391,.391-1.023,0-1.414Zm6,1.414c.391-.391,.391-1.023,0-1.414s-1.023-.391-1.414,0l-.793,.793-.793-.793c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414l.793,.793-.793,.793c-.391,.391-.391,1.023,0,1.414,.195,.195,.451,.293,.707,.293s.512-.098,.707-.293l3-3Zm9.293,9.293v2c0,2.206-1.794,4-4,4h-4c-2.206,0-4-1.794-4-4v-2c0-1.474,.81-2.75,2-3.444v-1.556c0-2.206,1.794-4,4-4s4,1.794,4,4v1.556c1.19,.694,2,1.97,2,3.444Zm-8-4h4v-1c0-1.103-.897-2-2-2s-2,.897-2,2v1Zm6,4c0-1.103-.897-2-2-2h-4c-1.103,0-2,.897-2,2v2c0,1.103,.897,2,2,2h4c1.103,0,2-.897,2-2v-2Zm-4-.5c-.828,0-1.5,.672-1.5,1.5s.672,1.5,1.5,1.5,1.5-.672,1.5-1.5-.672-1.5-1.5-1.5Z"/>
                                            </svg>
                                            <h2>Generate Temporary Password</h2>
                                        </div>
                                        <div class="inputLabelNotification">
                                            <div class="inputLabelNotificationInner">
                                                <label>Temporary Password</label>

                                                <div class="inputButtonContainer">
                                                    <input class="notification-input-style" placeholder="Temporary Password" name="delivery" id="deliveryInput" type="text" v-model="temporaryPassword">
                                                    <button type="submit" @click="generateCognitoTempPassword()">Generate</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="toggleTemporaryPassword" class="notifications-container-1">
                                        <div class="inputLabelNotification">
                                            <div class="inputLabelNotificationInner" style="width: 70%">
                                                <p><strong>By setting a temporary password, you are responsible for sharing it with the user.</strong></p>
                                                <p>The user will use this password to sign in once and will be required to create a new password immediately after.
                                                   This password will be gone once you close this window.
                                                </p>
                                                

                                                <div class="inputButtonContainer">
                                                    <input class="notification-input-style" disabled placeholder="Temporary Password" name="delivery" id="deliveryInput" type="text" v-model="temporaryPassword">
                                                    <button type="submit" @click="copyTempPassword()">Copy</button>
                                                </div>
                                                <p class="copied-alert" v-if="toggleCopiedAlert">Copied!</p>
                                            </div>
                                        </div>
                                    </div>

                                    <button class="print-button create-button update-notification" v-if="!toggleTemporaryPassword" @click="toggleSetTemporaryPassword()">Confirm Temporary Password</button>
                                    <button class="print-button create-button update-notification" v-if="toggleTemporaryPassword" @click="createUserTemporaryPassword()">Set Temporary Password</button>
                                    <button class="print-button update-notification" v-if="toggleTemporaryPassword" @click="toggleSetTemporaryPassword()">Cancel</button>
                                </div>
                            <!-- </div> -->
                        </div>
                        <div class="location-container">

                        
                        <div v-if="AdminUser" class="weight-container">
                            <div class="confirmLabelContainer service-data">
                                <div class="add-service-container">
                                    <div>
                                        <p style="font-weight: bold;">{{userData.userName}}</p>
                                    </div>

                                    <loading-charts v-if="removingUser"/>
                                    <loading-charts v-if="addingUserToGroup"/>
                                    <loading-charts v-if="loadingTable"/>

                                    <div v-for="group in listAllGroups" :key="group.GroupName">
                                            <div class="confirmLabelContainer group-remove-add">
                                                <div>
                                                    <label for="">{{group.GroupName}}</label>
                                                    <p style="font-size: 10px;">{{group.Description}}</p>
                                                </div>
                                                <button id="remove-button" :disabled="removingUser == true" @click="removeUserFromGroupFunc(group.GroupName)" style="margin-bottom: 0px;" class="print-button" v-if="userIsInGroup(group)">Remove</button>
                                                <button id="add-button" :disabled="addingUserToGroup == true" @click="addUserToGroupFunc(group.GroupName)" style="margin-bottom: 0px;" class="print-button create-button"  v-else>Add</button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="AdminUser" class="weight-container">
                            <account-locations :key="popupOpenKey" @checkBoxSelectID="checkBoxSelectID($event)" :jwtToken="jwtTokenAdmin" :userData="userDataAdmin" :selectedUserData="selectedUserData" :selectedAccountNo="selectedUserData.accountNo"/>
                        </div>
                        </div>
                    </div>
                    <button class="print-button" @click="UpdateUserGraphQL()">Update User</button>
            </div>
    </div>
  </div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API, Auth} from 'aws-amplify';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue';
import { addUserToGroup, getUsersGroupData, listAllUserGroups, removeUserFromGroup, getUsersAttributeData, updateUsersAttributeData } from '../../../graphql/mutations';
import { getUser } from '../../../graphql/queries';
import AccountLocations from '../LocationDashboard/AccountLocations.vue'

export default {
    props:['username', 'jwtToken', 'selectedAccountNo'],
    components:{
        AlertUser,
        LoadingCharts,
        AccountLocations
    },
    data(){
        return{
            userData: null,
            toggleAlertBox: false, 
            alertMessage: null,
            loadingData: false,
            loadingUserAttributes: false,
            validateCustomAddress: false,
            userCustomAddress: "",
            userServices: null,
            userServicesAWSJSON: "",
            serviceName: "",
            priceName: "",
            priceValue: "",
            routeCode: "",
            serviceLevelName: "",
            addNewService: false,
            addServiceObject: null,
            user: null,
            userDataAdmin: null,
            jwtTokenAdmin: "",
            AdminUser: false,
            selectedLocationID: null,
            selectedUserData: null,
            usersGroups: [],
            usersAttributeData: [],
            listAllGroups: [],
            removingUser: false,
            addingUserToGroup: false,
            attributeToEdit: {},
            inputNotify: '',
            inputNotifyNonDelivery: '',
            temporaryPassword: '',
            toggleTemporaryPassword: false,
            toggleCopiedAlert: false,
            popupOpenKey: 0
        }
    },
    computed:{
        userIsInGroup() {
            return group => {
                return this.usersGroups.some(item => item.GroupName === group.GroupName);
            };
        }
    },
    methods:{
        copyTempPassword() {
            if (!this.temporaryPassword) return;
            navigator.clipboard.writeText(this.temporaryPassword);
            this.toggleCopiedAlert = true;
            setTimeout(() => {
                this.toggleCopiedAlert = false;
            }, 2000);
        },
        toggleSetTemporaryPassword(){
            this.toggleTemporaryPassword = !this.toggleTemporaryPassword;
        },
        generateCognitoTempPassword() {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
            let password = "";

            for (let i = 0; i < 12; i++) {
                const array = new Uint32Array(1);
                window.crypto.getRandomValues(array);
                password += chars[array[0] % chars.length];
            }

            this.temporaryPassword = password;
        },
        async createUserTemporaryPassword() {
            this.loadingTable = true;

            const tempPassword = this.temporaryPassword;
            const username = this.userData.userName;

            const mutation = `
                mutation SetTempPassword($input: updateUsersAttributeDataInput!) {
                    updateUsersAttributeData(input: $input) {
                        username
                    }
                }
            `;

            try {
                await API.graphql({
                query: mutation,
                variables: {
                    input: {
                    username,
                    attributeData: [
                        { Name: "setTempPassword", Value: tempPassword }
                    ]
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                this.alertMessage = "Temporary password set successfully.";
                this.toggleAlertBox = true;
            } catch (error) {
                console.log(error);
                this.alertMessage = "Failed to set temporary password.";
                this.toggleAlertBox = true;
            } finally {
                this.loadingTable = false;
            }
        },
        inputIsValid(){
            if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.inputNotify) == true){
                this.userData.deliveryEmail.push(this.inputNotify);
            }else if(/^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(this.inputNotify) == true){
                let trimPhone = this.inputNotify.replace(/[^0-9]/g, '');
                this.userData.deliveryPhone.push(trimPhone)
            }else{
                this.alertMessage = "Please enter a valid email or phone number.";
                this.toggleAlertBox = true;
            }
        },
        inputIsValidNonDelivery(){
            if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.inputNotifyNonDelivery) == true){
                this.userData.nonDeliveryEmail.push(this.inputNotifyNonDelivery);
            }else if(/^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(this.inputNotifyNonDelivery) == true){
                let trimPhone = this.inputNotifyNonDelivery.replace(/[^0-9]/g, '');
                this.userData.nonDeliveryPhone.push(trimPhone)
            }else{
                this.alertMessage = "Please enter a valid email or phone number.";
                this.toggleAlertBox = true;
            }
        },
        RemoveEmail(index){
            this.userData.deliveryEmail.splice(index, 1)
        },
        RemovePhone(index){
            this.userData.deliveryPhone.splice(index, 1)
        },
        RemoveNonDelivEmail(index){
            this.userData.nonDeliveryEmail.splice(index, 1)
        },
        RemoveNonDelivPhone(index){
            this.userData.nonDeliveryPhone.splice(index, 1)
        },
        toggleEditMode(attribute) {
            this.attributeToEdit = {... attribute};
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        async checkBoxSelectID(event){
            this.selectedLocationID = event;
            //await this.updateUserLocationID();
        },
        async UpdateUserGraphQL(){
            this.loadingTable = true;
            const updateUserMutation = `
                mutation UpdateUser($input: UpdateUserInput!) {
                    updateUser(input: $input) {
                    userName
                    fullname
                    userEmail
                    locationID
                    }
                }
            `;

            try {
                let input = {
                    userName: this.userData.userName,
                    webKey: this.userData.webKey,
                    deliveryEmail: this.userData.deliveryEmail,
                    deliveryPhone: this.userData.deliveryPhone,
                    nonDeliveryEmail: this.userData.nonDeliveryEmail,
                    nonDeliveryPhone: this.userData.nonDeliveryPhone,
                    deliveryInstructions: this.userData.deliveryInstructions,
                    ref1: this.userData.ref1
                };

                if (this.selectedLocationID) {
                    input.locationID = this.selectedLocationID;
                }

                let userReturnData = await API.graphql({
                    query: updateUserMutation,
                    variables: {
                        input
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userData = userReturnData.data.updateUser;
                console.log("User Data: ", this.userData)
                this.getAccountUserClick();
                this.toggleAlertBox = true;
                this.alertMessage = "Updated user information"
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to update user information"
                this.getAccountUserClick();
            }finally{
                this.loadingTable = false;
            }
        },
        async generateWebKey(length = 10) {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            
            for (let i = 0; i < length; i++) {
                const randomIndex = Math.floor(Math.random() * chars.length);
                result += chars[randomIndex];
            }

            this.userData.webKey = result;
        },
        async getAccountUserClick(){
            this.loadingTable = true;
            let graphqlQuery = `query getUser{
                getUser(userName: "${this.username}"){
                    userName
                    locationID
                    accountNo
                    userEmail
                    ref1
                    nonDeliveryEmail
                    nonDeliveryPhone
                    deliveryPhone
                    deliveryEmail
                    deliveryInstructions
                    webKey
                    locationAddress{
                        id
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                            }
                        }
                    }
                }
            }`
            
            try{
                let getUser = await API.graphql({
                query:  graphqlQuery,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                
                this.userData = getUser.data.getUser;
                this.selectedUserData = getUser.data.getUser;
                this.userData.nonDeliveryEmail = this.userData.nonDeliveryEmail ?? [];
                this.userData.nonDeliveryPhone = this.userData.nonDeliveryPhone ?? [];
                this.userData.deliveryEmail = this.userData.deliveryEmail ?? [];
                this.userData.deliveryPhone = this.userData.deliveryPhone ?? [];
                this.userData.deliveryInstructions = this.userData.deliveryInstructions ?? "";
                // this.userServices = JSON.parse(getUser.data.getUser.Services)
                await this.getUsersGroupDataFunc();
                await this.listAllUserGroupsFunc();
                await this.getUsersAttributeDataFunc();
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting user"
                }
            }finally{
                this.loadingTable = false;
            }
        },
        async copyWebKey() {
            try {
                await navigator.clipboard.writeText(this.userData.webKey);
                alert('WebKey copied to clipboard!');
            } catch (err) {
                console.error('Failed to copy text:', err);
                alert('Failed to copy WebKey.');
            }
        },
        async GetUserGraphQL(){
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: getUser,
                    variables: {
                            userName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userDataAdmin = userReturnData.data.getUser;
            } catch (error) {
                console.log(error)
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information"
            }finally{
                this.loadingUser = false;
            }
        },
        async addUserToGroupFunc(groupName){
            this.addingUserToGroup = true;
            try{
                let addUserToCognitoGroup = await API.graphql({
                query:  addUserToGroup,
                variables:{
                    input:{
                        username: this.userData.userName,
                        groupname: groupName
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "User group updated"
                console.log(addUserToCognitoGroup)
                await this.getUsersGroupDataFunc();
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error updating user group"
                }
            }finally{
                this.addingUserToGroup = false;
            }
        },
        async removeUserFromGroupFunc(groupName){
            this.removingUser = true;
            try{
                let removeUserFromGroupData = await API.graphql({
                query:  removeUserFromGroup,
                variables:{
                    input:{
                        username: this.userData.userName,
                        groupname: groupName
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "User removed from group"
                console.log(removeUserFromGroupData)
                await this.getUsersGroupDataFunc();
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error removing user from group"
                }
            }finally{
                this.removingUser = false;
            }
        },
        async getUsersGroupDataFunc(){
            this.loadingTable = true;
            try{
                let getUsersGroups = await API.graphql({
                query:  getUsersGroupData,
                variables:{
                    input:{
                        username: this.userData.userName
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.usersGroups = getUsersGroups.data.getUsersGroupData.Groups;
                console.log(getUsersGroups)
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting users groups"
                }
            }finally{
                this.loadingTable = false;
            }
        },
        async getUsersAttributeDataFunc(){
            this.loadingUserAttributes = true;
            try{
                let getUsersAttribute = await API.graphql({
                query:  getUsersAttributeData,
                variables:{
                    input:{
                        username: this.userData.userName
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.usersAttributeData = getUsersAttribute.data.getUsersAttributeData.attributeData;
                console.log(getUsersAttribute)
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting users attribute data"
                }
            }finally{
                this.loadingUserAttributes = false;
            }
        },
        async updateUsersAttributeDataFunc(){
            this.loadingUserAttributes = true;
            delete this.attributeToEdit.__typename
            try{
                let updateUsersAttribute = await API.graphql({
                query:  updateUsersAttributeData,
                variables:{
                    input:{
                        username: this.userData.userName,
                        attributeData: this.attributeToEdit
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(updateUsersAttribute.data.updateUsersAttributeData.username){
                    this.toggleAlertBox = true;
                    this.alertMessage = "User attribute updated"
                    if(this.attributeToEdit.Name == "email"){
                        await this.updateUserEmail(this.attributeToEdit.Value)
                    }
                    this.attributeToEdit = {}
                }
                console.log(updateUsersAttribute)
                await this.getUsersAttributeDataFunc();
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error updating users attribute data"
                }
            }finally{
                this.loadingUserAttributes = false;
            }
        },
        async updateUserEmail(email){
            this.loadingUserAttributes = true;
            try{
                let updateUserData = await API.graphql({
                query: `mutation MyMutation($input: UpdateUserInput!) {
                    updateUser(input: $input) {
                        userName
                        userEmail
                    }
                }`,
                variables:{
                    input:{
                        userName: this.userData.userName,
                        userEmail: email
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(updateUserData.data.updateUser.username){
                    this.toggleAlertBox = true;
                    this.alertMessage = "User attribute updated"
                }
                console.log(updateUserData)
                await this.getAccountUserClick();
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error updating users email on dynamodb"
                }
            }finally{
                this.loadingUserAttributes = false;
            }
        },
        async listAllUserGroupsFunc(){
            this.loadingTable = true;
            try{
                let listAllUserGroupsData = await API.graphql({
                query:  listAllUserGroups,
                variables:{
                    input:{
                        username: this.userData.userName
                    }
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.listAllGroups = listAllUserGroupsData.data.listAllUserGroups.Groups;
                console.log(listAllUserGroupsData)
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting groups"
                }
            }finally{
                this.loadingTable = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        closeAddressInfo(){
            this.$emit('closeAddressInfo', false)
        },
        AddUserServiceToggle(){
            this.addNewService = !this.addNewService;
            this.serviceName = "";
            this.priceName = "";
            this.priceValue = "";
            this.routeCode = "";
            this.serviceLevelName = "";
        },
        async AddUserService(){
            const priceObject = {
                [this.priceName]: this.priceValue
            };

            this.userServices[this.serviceName] = {
                Price: priceObject,
                RouteCode: this.routeCode,
                ServiceLevelName: this.serviceLevelName
            }

            await this.addUserToGroupFunc();

            this.serviceName = "";
            this.priceName = "";
            this.priceValue = "";
            this.routeCode = "";
            this.serviceLevelName = "";
            this.addNewService = false;
        },
        async RemoveUserService(serviceName){
            delete this.userServices[serviceName]
            await this.addUserToGroupFunc();
        }
    },
    mounted(){
        this.getAccountUserClick();
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtTokenAdmin = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();

            if(this.user.signInUserSession.idToken.payload['cognito:groups']){
                this.user.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                    if(group == 'Admin'){
                        this.AdminUser = true;
                    }
                })
            }
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        this.generateCognitoTempPassword();
        setTimeout(() => {
            this.popupOpenKey += 1;
        }, 2000);
    }
}
</script>

<style scoped>
/* SVG Styles */

    .st0{
        fill: none;
        stroke: #000000;
        stroke-width: 8;
        stroke-miterlimit: 10;
    }

    .st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}


    .cls-1-alt{
        fill: none;
        stroke: #000;
        stroke-miterlimit: 10;
        stroke-width: 8px;
    }

    .cls-1 {
        fill: none;
        stroke: #000;
        stroke-miterlimit: 10;
        stroke-width: 8px;
    }

    .cls-2 {
        fill: none;
        stroke: #000;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 12px;
    }

    .cls-2-alt{
        stroke: #000;
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 11px;
    }

    input, select{
        /* padding: 10px; */
        font-size: 15px;
        border: 1px solid rgba(0,0,0,.336);
        border-radius: 15px;
        outline: none;
        margin-top: 5px;
    }

.copied-alert {
  margin-left: 8px;
  font-size: 12px;
  color: #2e7d32;
  opacity: 0;
  transform: translateY(-4px);
  animation: copiedFade 1.5s ease forwards;
}

@keyframes copiedFade {
  0% {
    opacity: 0;
    transform: translateY(-4px);
  }
  20% {
    opacity: 1;
    transform: translateY(0);
  }
  80% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-4px);
  }
}

.confirmLabelContainer img{
    width: 50%;
    max-width: 200px;
    margin-top: 5px;
    border-radius: 5px;
}

.inputButtonContainer {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 85%
}

.inputButtonContainer button {
	padding: 10px;
	background-color: #33f18a;
	box-shadow: rgba(0, 0, 0, .05) 0 1px 5px;
	border-radius: 0 15px 15px 0;
	cursor: pointer;
	transition-duration: .5s;
	color: #fff;
	font-size: 15px;
	border: .25px solid #b3b3b3;
	border-left: none
}

.inputButtonContainer button:hover {
	background-color: #30df9c;
	transition-duration: .5s
}

.notification-input-style {
	padding: 10px;
	font-size: 15px;
	border: .25px solid rgba(0, 0, 0, .336);
	border-radius: 15px 0 0 15px;
	outline: 0;
    margin-top: 0 !important;
}

.addedItems {
	display: flex;
	flex-direction: row;
	align-items: center;
    justify-content: space-between;
	width: 100%;
	height: 25px;
	animation: itemDropdown;
	animation-duration: .5s
}

.notifications-container-1{
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.addedItems button {
	white-space: nowrap; /* prevents wrapping on the button */
}

.emailsAddedContainer {
    display: flex;
	flex-direction: column;
	align-items: flex-start;
	overflow-x: auto; /* or auto if you want scroll */
	width: 80%;
	max-width: 80%;
	white-space: nowrap;
	word-break: break-word;
    padding: 5px 15px 5px 0;
	padding: 10px;
    box-shadow: rgba(0, 0, 0, .164) 0 1px 10px;
	background-color: #fff;
	border-radius: 15px;
    margin-top: 10px;
	margin-bottom: 10px;
	/* display: flex;
	justify-content: flex-start;
	flex-direction: column;
	align-items: flex-start;
	margin-top: 10px;
	margin-bottom: 10px;
	overflow-x: auto;
	box-shadow: rgba(0, 0, 0, .164) 0 1px 10px;
	background-color: #fff;
	border-radius: 15px;
	width: fit-content;
	padding: 5px 15px 5px 0;
	padding: 10px;
    max-width: 80%; */
}

.removeItemButton {
	/* margin-left: 10px; */
	margin-top: 0;
	cursor: pointer;
	border: none;
	border-radius: 15px;
	background-color: #32ccfe;
	color: #fff;
	transition-duration: .5s
}

.removeItemButton:hover {
	background-color: #2db4e0;
	color: #d4d3d3;
	transition-duration: .5s
}

textarea {
	width: 70%;
	padding: 10px;
	font-size: 15px;
	border: 1px solid rgba(0, 0, 0, .336);
	border-radius: 15px;
	outline: 0
}

.delivery-instruction-container{
    margin-top: 10px;
    display: flex;
    flex-direction: column;
}

.char-counter {
  font-size: 0.6rem;
  color: #555;
}

.web-key-label{
    margin-top: 15px !important;
    margin-bottom: 0;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px 10px;
    width: fit-content;
}

.webkey-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.webkey-container input{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
}

.webkey-container button{
    margin-left: 0 !important;
    margin-top: 5px;
}

.update-notification{
    margin-left: 0 !important;
    margin-top: 5px;
}

.group-remove-add{
    width: 100%;
    display: flex;
    border-bottom: 1px solid rgba(0,0,0,.336);
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.main-container-shipmentinfo{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: 0;
    padding: 0;
    z-index: 10;
}

@keyframes shipment-details-animate {
    from{
        margin-top: -2%;
    }
    to{
        margin-top: 2.5%;
    }
}

.inner-container{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    flex-direction: column;
}

.confirm-container-main{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: fit-content;
    max-height: 90vh;
    overflow-x: auto;
    animation: shipment-details-animate 1s ease;
    margin-top: 2.5%;
    box-shadow: rgba(0, 0, 0, 0.164) 0px 1px 10px;
    background-color: #fff;
    border-radius: 25px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.confirm-header-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 15px 0 15px;
    justify-content: space-between;
}

.confirm-header-container img{
    width: 40px;
    margin-right: 15px;
}

.weight-container{
    background-color: #fff;
    margin: 15px;
    padding: 10px;
    border-radius: 25px;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
    width: fit-content;
}

.weight-container label{
    margin-right: 5px;
}

.location-container{
    display: flex;
    flex-wrap: wrap;
}

.confirmContainerInner{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    text-align: left;
    padding: 10px;
    flex-wrap: wrap;
}

.inner-overflow-container{
    max-height: 90%;
    overflow-y: auto;
    margin-bottom: 10px;
    margin: 5px;
    border-top: 1px #d5d5d5 solid;
    border-bottom: 1px #d5d5d5 solid;
}

.confirmContainerInner1{
    background-color: #f5f5f5;
    margin: 5px;
    padding: 10px;
    border-radius: 25px;
    flex-basis: 45%;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 10px;
}

.notifications-container{
    flex-basis: 30%;
}

.temp-pass-container{
    flex-basis: 10%;
}

.locationContainer{
    padding-top: 0px;
}

.confirmContainerInner1 h2{
    margin: 0;
    text-align: left;
    white-space: nowrap;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

.confirm-container-address{
    display: flex;
    flex-direction: row;
    /* width: 100%; */
    flex-wrap: wrap;
}

.package-details-header{
    background-color: #32ccfe;
    color: #fff;
    padding: 10px;
    border-radius: 50px;
    width: fit-content;
    margin: 0;
}

.confirmContainer{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.confirmContainerInner label{
    background-color: transparent;
    border: none;
    padding: 0px;
    margin-right: 10px;
    font-weight: bold;
    white-space: nowrap;
}

.confirmLabelContainer{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: auto;
}

.confirmLabelContainer p{
    margin-top: 5px;
    margin-bottom: 5px;
}

.confirmLabelContainer2{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding-bottom: 5px;
}

.service-container{
    display: flex;
    margin: 5px;
    flex-direction: column;
}

.close-shipment-info{
    width: 30px;
    height: 30px;
    margin-right: 5%;
    margin-top: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.close-shipment-info:hover{
    transition-duration: .5s;
    border-radius: 999px;
    background-color: #e4e4e4;
}

.print-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-left: 25px;
    /* margin-top: 5px; */
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.print-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

.create-button{
    background-color: #33f18a;
    margin-left: 20px;
}

.create-button:hover{
    transition-duration: .5s;
    background-color: #31d77b;
}

.close-shipment-info-container{
    display: flex;
    justify-content: flex-end;
}

@media only screen and (max-width: 820px){
    .confirm-container-main{
        width: 90%;
    }

    .weight-container{
        background-color: #fff;
        margin: 5px 15px;
        width: fit-content;
    }

    .confirmContainerInner{
        flex-direction: column;
        flex-wrap: wrap;
    }

    .confirmContainerInner1{
        width: fit-content;
    }

    .package-details-header{
        font-size: 1.6em;
    }
}

@media only screen and (max-width: 530px){
    .service-data{
        flex-direction: column;
    }
}
</style>